import type { ColumnDef } from '@tanstack/angular-table';
import type { BadgeStatus } from '../../admin/shared';
import type { CheckinRowVm } from './checkin-row.vm';

/**
 * Colunas como dado. Todo formato já vem resolvido pelo viewmodel — aqui não
 * há `new Date()`, `||` nem HTML em string.
 *
 * Nenhuma coluna é `enableSorting: true`: `INGRESSOS` (api/v2/ingresso/
 * $idEvento$/buscar) não tem enum `<Operação>FieldSort` gerado pelo orval, e
 * chave de sort que o backend ignora vira enfeite silencioso.
 */
export const CHECKIN_COLUMNS: ColumnDef<CheckinRowVm, unknown>[] = [
  { id: 'status', header: 'Status', accessorFn: (r) => r.statusLabel },
  { id: 'participante', header: 'Participante', accessorFn: (r) => r.nome },
  { id: 'codigo', header: 'Código', accessorFn: (r) => r.codigo },
  { id: 'email', header: 'E-mail', accessorFn: (r) => r.email },
  { id: 'documento', header: 'Documento', accessorFn: (r) => r.documento },
  { id: 'lote', header: 'Lote', accessorFn: (r) => r.lote },
  // Rótulo "Check-ins": a célula mostra se foi feito E abre as janelas.
  { id: 'janela', header: 'Check-ins', accessorFn: (r) => r.janelaResumo },
  { id: 'checkin', header: 'Check-in', accessorFn: (r) => r.dataCheckinLabel },
  { id: 'operador', header: 'Operador', accessorFn: (r) => r.operador },
];

/** Colunas que saem como pílula em vez de texto. */
/**
 * Vazio de propósito: `status` virou ícone e `janela` virou dropdown, os dois
 * via `cellTemplates`. Mantido exportado porque a tabela aceita o input e
 * outra coluna pode voltar a ser pílula.
 */
export const CHECKIN_BADGE_COLUMNS: Record<string, (r: CheckinRowVm) => BadgeStatus | null> = {};

/** Escondidas por padrão; o usuário liga nas configurações da tabela. */
export const CHECKIN_COLUNAS_OCULTAS = [
  'codigo',
  // A data do check-in agora aparece no topo do dropdown da coluna Check-ins
  // ("Check-in realizado em ..."); manter as duas é dizer a mesma coisa duas
  // vezes numa linha que já é larga.
  'checkin',
];

/**
 * Larguras máximas por coluna, em px.
 *
 * Nome de participante é campo livre e chega com coisas como "Carlos Teixeira
 * (Mestre Pit Bull) - Grupo de Capoeira Mistura de Raças": sem teto, uma linha
 * estica a coluna e empurra Código/E-mail/Documento para fora da tela. Truncado
 * com reticências, o texto inteiro fica no `title` (hover).
 *
 * No mobile não há truncagem: o card mostra o nome inteiro quebrando linha, que
 * é o comportamento certo onde não existe hover.
 */
export const CHECKIN_COLUNAS_TRUNCADAS: Record<string, number> = {
  participante: 260,
  email: 220,
  lote: 180,
  operador: 150,
};
